// Live password requirement hints, shown under a password field. Mirrors the
// backend AUTH_PASSWORD_VALIDATORS so the user sees the rules before submitting.
import { Box, Typography } from '@mui/material';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import RadioButtonUncheckedIcon from '@mui/icons-material/RadioButtonUnchecked';
import { useColors } from '../context/ThemeContext';

const RULES = [
  { key: 'len', label: 'Au moins 8 caractères', test: (p) => p.length >= 8 },
  { key: 'special', label: 'Au moins un caractère spécial (!?@#…)', test: (p) => /[^A-Za-z0-9]/.test(p) },
  { key: 'digit', label: 'Au moins 1 chiffre', test: (p) => /\d/.test(p) },
];

export default function PasswordHints({ value = '' }) {
  const colors = useColors();
  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', gap: 0.25 }}>
      {RULES.map((rule) => {
        const ok = rule.test(value);
        return (
          <Box key={rule.key} sx={{ display: 'flex', alignItems: 'center', gap: 0.75 }}>
            {ok ? (
              <CheckCircleIcon sx={{ fontSize: 14, color: colors.success }} />
            ) : (
              <RadioButtonUncheckedIcon sx={{ fontSize: 14, color: colors.textSecondary }} />
            )}
            <Typography variant="caption" sx={{ color: ok ? colors.success : colors.textSecondary }}>
              {rule.label}
            </Typography>
          </Box>
        );
      })}
    </Box>
  );
}
